import { datadogRum } from '@datadog/browser-rum'
import { reactPlugin } from '@datadog/browser-rum-react'

let rumInitialized = false

/**
 * Socket.IO polls GET /ws on the page origin; when the gateway cannot reach kba-ws
 * this produces endless 502 resource events in RUM (same class of noise as /api/ping on kba-be).
 */
export function shouldExcludeRumEvent(event) {
  if (event.type !== 'resource') {
    return false
  }

  const url = event.resource?.url || ''
  return /\/ws(\?|$|\/)/.test(url) || url.includes('socket.io')
}

/**
 * Initialize Datadog RUM when build-time env vars are set (CI / .env.local).
 * Skipped in Jest and when credentials are absent (local dev without RUM).
 */
export function initDatadogRum() {
  const applicationId = import.meta.env.REACT_APP_DATADOG_RUM_APPLICATION_ID
  const clientToken = import.meta.env.REACT_APP_DATADOG_RUM_CLIENT_TOKEN

  if (!applicationId || !clientToken) {
    return
  }

  if (import.meta.env.MODE === 'test') {
    return
  }

  const env = import.meta.env.REACT_APP_DATADOG_RUM_ENV || 'development'
  const site = import.meta.env.REACT_APP_DATADOG_RUM_SITE || 'datadoghq.eu'
  const service = import.meta.env.REACT_APP_DATADOG_RUM_SERVICE || 'kba-fe'
  const version = import.meta.env.REACT_APP_DATADOG_RUM_VERSION || undefined

  datadogRum.init({
    applicationId,
    clientToken,
    site,
    service,
    env,
    version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [
      { match: /^https:\/\/.*\.keybiodiversityareas\.org/, propagatorTypes: ['datadog'] },
      { match: /^\/api\//, propagatorTypes: ['datadog'] },
    ],
    beforeSend: (event) => !shouldExcludeRumEvent(event),
    // router: false — app uses BrowserRouter + custom history, not createBrowserRouter
    plugins: [reactPlugin({ router: false })],
  })

  rumInitialized = true
}

/**
 * Attach logged-in user to the active RUM session (id only; no email/name for privacy).
 */
export function setDatadogRumUser(profile) {
  if (!rumInitialized || !profile?.id) {
    return
  }

  datadogRum.setUser({
    id: String(profile.id),
  })
}

export function clearDatadogRumUser() {
  if (!rumInitialized) {
    return
  }

  datadogRum.clearUser()
}
